import Bank from '@/domain/models/Bank';
import BankConfig from '@/domain/models/BankConfig';
import RemittanceSchedule from '@/domain/models/remittanceSchedule/RemittanceSchedule';
import Repository from '@/repositories/base/Repository';
import IUpdateScheduleParams from '@/views/remittanceScheduleConfig/interfaces/IUpdateScheduleParams';

export default class RemittanceScheduleRepository extends Repository {
    public async getRemittanceSchedule(companyGroupId: number) {
        const { data: response } = await this.datasource.get(`/company-groups/${companyGroupId}/remittance-schedule-configs`);

        return response.data.map(RemittanceSchedule.make);
    }

    public async getBanks(companyGroupId: number): Promise<Array<BankConfig>> {
        const { status, data: response } = await this.datasource.get(`/company-groups/${companyGroupId}/bank-configs/send-type-is-api`);

        if (status !== 200) {
            throw new Error('Ops, aconteceu algum problema ao buscar o banco do dia');
         }

        return response.data.map(BankConfig.make);
    }

    public async updateSchedules(
        companyGroupId: number, data: IUpdateScheduleParams,
    ): Promise<void> {
         const { status } = await this.datasource.send(`/company-groups/${companyGroupId}/remittance-schedule-configs/set-default-bank-config`, {
            bank_config_id: data.bank,
            selected_company_ids: data.companies,
         });

         if (status !== 200) {
            throw new Error('Ops, aconteceu algum problema ao atualizar o banco do dia');
         }
    }
}
